export function newId() {
  // First character is an 'a', it's good practice to tag id to begin with a letter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return 'axxxxxxxxxxx'.replace(/[x]/g, function (_) {
    // tslint:disable-next-line:no-bitwise
    const val = (Math.random() * 16) | 0;
    return val.toString(16);
  });
}
